import { useCallback, useEffect, useMemo, useRef, useState } from "react"
import { ErrorCard, LoadingCard, MainContainer, } from "../../components"
import { Button, Autocomplete, AutocompleteItem, Checkbox, Input, addToast, Select, SelectItem, Chip, Card, CardBody, Divider, Modal, NumberInput } from "@heroui/react"
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers"
import dayjs from "dayjs"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { apiRoute, ENUM_BILL_TYPE, ENUM_CURRENCY_SETTING_VAL, ENUM_ENTRY_TYPE, ENUM_INPUT_TYPE, ENUM_MOD_NAME, ENUM_MOD_PARAMETER, ENUM_STATUS, ENUM_TRADE_TYPE, ENUM_TRADEOF_CODE, ENUM_TRADEOF_TYPE, getModMandatory, getModValue, getModVisiblity, linksUrl, URIEncrypt, } from "../../constants/enum"
import { isMobile } from "react-device-detect"
import { useFetchWithBody, usePost } from "../../api/reactQueryCustomHooks"
import { useDispatch, useSelector } from "react-redux"
import { faCancel, faCircleLeft, faExclamationTriangle, faFileExcel, faGem, faPlus, faSave, faSquareXmark, faTrashCan } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { toast } from "react-toastify"
import { useNavigate, useParams } from "react-router-dom"
import { DataGrid, GridPagination, useGridApiContext } from "@mui/x-data-grid"
import { calculateTotal, convertDate, funCheckNumber } from "../../Utility/utility"
import { Box, Typography } from "@mui/material"
import { resetAcInfo, setIsMemoRedirect, setRedirectLink } from "../../state/accountSlice"
import { setNewEntryMode, setDetailParams } from "../../state/invoiceEntrySlice"
import * as XLSX from 'xlsx';
import { useModalToast } from "../../components/modalToast/ModalToastContext"


const MemoFinalization = () => {
    const { compCode, compState, isMultipleCompany, startDate, endDate } = useSelector((state) => state.company)
    const { memoParams } = useSelector((state) => state.memoEntry)
    const { user } = useSelector((state) => state.auth);
    const navigate = useNavigate();
    const { btype, trdtype, ptype } = useParams();
    const [selectedGridRowId, setSelectedGridRowId] = useState()
    const [modSettingParams, setModSettingParams] = useState()
    const [entryLabel, setEntryLabel] = useState("")
    const [selBillType, setSelBillType] = useState("")
    const [selTradeOf, setSelTradeOf] = useState("")
    const [selPktType, setSelPktType] = useState("")
    const [naviCode, setnaviCode] = useState("")
    const [mixStockParams, setMixStockParams] = useState("")
    const [isNewEntry, setIsNewEntry] = useState(true)
    const [CurrencySetting, setCurrencySetting] = useState("")
    const dispatch = useDispatch();
    const [isExcelImport, setIsExcelImport] = useState(false)
    const [isImportByStockId, setIsImportByStockId] = useState(false)
    const [ExcelColMap, setExcelColMap] = useState([])
    const [excelData, setExcelData] = useState([])
    const [selActionType, setSelActionType] = useState("")
    const [chkGridSelAllFinal, setChkGridSelAllFinal] = useState(false)
    const [chkGridSelAllReturn, setChkGridSelAllReturn] = useState(false)
    const [isUseMfgNoAsMktno, setIsUseMfgNoAsMktno] = useState(true)
    const [finalMemos, setFinalMemos] = useState([])
    const fileInputRef = useRef(null)
    const submitLockRef = useRef(false);//
    const { show } = useModalToast()

    const { isPending: isLoadingData, isError: isErrorMastData, data: masterData = [], mutate: filterMatserData } = usePost({
        url: apiRoute.memoEntry.entryMasterData,
        queryKey: "fetchMemoMasterData",

    })

    const { isPending: isLoadingGridData, data: gridMasterData = [] } = useFetchWithBody({
        url: apiRoute.memoEntry.gridMasterData,
        queryKey: "fetchMemoGridMasterData",
    })

    const { data: excelTempData, mutate: filterXlTemplate } = usePost({
        url: apiRoute.stockEntry.getExcelTemplate,
        queryKey: "funExcelTemplateStock",
        // inputData: {
        //     tempname: selPktType=='SNG'?'StockImport':'StockImportMix'
        // }
    })

    const onSuccessTasks = (data) => {
        submitLockRef.current = false
        if (data && data.length > 0) {
            let obj = {
                comp_code: data[0].CompCode,
                transaction_id: data[0].TransactionId,
                bill_type: data[0].BillType,
                trade_of: data[0].TradeOf,
                status: data[0].Status
            }
            dispatch(setNewEntryMode(false))
            dispatch(setDetailParams(obj))
            if (selPktType == 'MIX')
                navigate(naviCode + btype + "/" + trdtype + "/" + ptype + linksUrl.mixEntry + linksUrl.invoiceEntry.createInvoiceEntry)
            else
                navigate(naviCode + btype + "/" + trdtype + "/" + ptype + linksUrl.invoiceEntry.createInvoiceEntry)
        }
        else
            navigate(funGetMasterLink());
    }
    const { isError, isPending, mutate: funAddUpdate } = usePost({
        url: apiRoute.finalizeEntry.add_update,
        queryKey: "funAddUpdateMemo",
        onSuccessTasks
    })

    const { isError: isErrorDetail, data: detail = [], mutate: funGetDetail } = usePost({
        url: apiRoute.memoEntry.fetchEntryDetail,
        queryKey: "fetchMemoDetail",
    });


    const { isError: isErrorModSet, data: modSetting = [], mutate: filterModSetting } = usePost({
        url: apiRoute.modSetting.getMultiModSetting,
        queryKey: "fetchModSettingInwardItem",
    })

    const isSinglePacket = () => {
        if (ptype != "") {
            if (ptype == URIEncrypt.SinglePacket)
                return true
            else
                return false
        }
        else
            return false
    }
    let gridData = []
    useEffect(() => {
        if (isMultipleCompany)
            navigate(linksUrl.dashboard.tradingDashboard)

        const params = [URIEncrypt.Polish, URIEncrypt.Rough, URIEncrypt.Rejection]
        if (!params.includes(String(trdtype)) || ![URIEncrypt.Sale, URIEncrypt.Purchase].includes(String(btype))
            || ![URIEncrypt.SinglePacket, URIEncrypt.Mix].includes(ptype))
            navigate(linksUrl.dashboard.tradingDashboard)

        if (btype && btype != "" && trdtype && trdtype != "" && ptype && ptype != "") {
            let t_tradeof = ''
            let t_entryLabel = ''
            let t_billtype = ''
            let t_pktType = ''
            let t_btype = btype.toLowerCase()
            let t_trdtype = trdtype.toLowerCase()
            let modName = ''

            if (ptype == URIEncrypt.SinglePacket)
                t_pktType = 'SNG'
            else
                t_pktType = 'MIX'
            if (t_btype == URIEncrypt.Sale.toLowerCase()) {
                t_billtype = 'S'
            }
            else if (t_btype == URIEncrypt.Purchase.toLowerCase()) {
                t_billtype = 'P'
            }
            if (t_trdtype == URIEncrypt.Polish.toLowerCase()) {
                t_tradeof = ENUM_TRADEOF_CODE.Polish
                t_entryLabel = "Polish Diamond "
                if (t_billtype == 'S') { modName = isSinglePacket() ? ENUM_MOD_NAME.SalePolishMemoSingle : ENUM_MOD_NAME.SalePolishMemoMix }
                else if (t_billtype == 'P') { modName = isSinglePacket() ? ENUM_MOD_NAME.PurchasePolishMemoSingle : ENUM_MOD_NAME.PurchasePolishMemoMix }
                setnaviCode(t_billtype == 'S' ? linksUrl.saleEntry.roughDiamond : t_billtype == 'P' ? linksUrl.purchaseEntry.roughDiamond : "")
            }
            else if (t_trdtype == URIEncrypt.Rough.toLowerCase()) {
                t_tradeof = ENUM_TRADEOF_CODE.Rough
                t_entryLabel = "Rough Diamond "
                if (t_billtype == 'S') { modName = isSinglePacket() ? ENUM_MOD_NAME.SaleRoughMemoSingle : ENUM_MOD_NAME.SaleRoughMemoMix }
                else if (t_billtype == 'P') { modName = isSinglePacket() ? ENUM_MOD_NAME.PurchaseRoughMemoSingle : ENUM_MOD_NAME.PurchaseRoughMemoMix }
                setnaviCode(t_billtype == 'S' ? linksUrl.saleEntry.roughDiamond : t_billtype == 'P' ? linksUrl.purchaseEntry.roughDiamond : "")
            }
            else if (t_trdtype == URIEncrypt.Rejection.toLowerCase()) {
                t_tradeof = ENUM_TRADEOF_CODE.Rejection
                t_entryLabel = "Rejection Diamond "
                if (t_billtype == 'S') { modName = isSinglePacket() ? ENUM_MOD_NAME.SaleRejectionMemoSingle : ENUM_MOD_NAME.SaleRejectionMemoMix }
                else if (t_billtype == 'P') { modName = isSinglePacket() ? ENUM_MOD_NAME.PurchaseRejectionMemoSingle : ENUM_MOD_NAME.PurchaseRejectionMemoMix }
                setnaviCode(t_billtype == 'S' ? linksUrl.saleEntry.roughDiamond : t_billtype == 'P' ? linksUrl.purchaseEntry.roughDiamond : "")
            }

            setSelTradeOf(t_tradeof)
            setSelBillType(t_billtype)
            setEntryLabel(t_entryLabel)
            setSelPktType(t_pktType)
            filterMatserData({
                data: {
                    compcode: compCode.join(","),
                    tradeof: t_tradeof,
                    billtype: t_billtype,
                    pkttype: t_pktType

                }
            })
            filterXlTemplate({
                data: {
                    tempname: t_pktType == 'SNG' ? 'MemoImport' : ""
                }
            })
            filterModSetting({
                data: {
                    page_mod: modName,
                    master_mod: ENUM_MOD_NAME.GeneralSettings
                }
            })
            if (memoParams && Object.keys(memoParams).length > 0) {
                const { comp_code, transaction_id, bill_type, trade_of } = memoParams

                funGetDetail({
                    data: {
                        compcode: comp_code,
                        transactionid: transaction_id,
                        billtype: bill_type,
                        tradeof: trade_of
                    }
                })
            }
        }
    }, [btype, trdtype])


    useEffect(() => {
        if (modSetting && Object.keys(modSetting).length > 0) {
            const modData = modSetting.pageData
            const generalData = modSetting.masterData
            setCurrencySetting(getModValue(ENUM_MOD_PARAMETER.GeneralSetting.CurrencyType, generalData) ?? ENUM_CURRENCY_SETTING_VAL.RS)
            const mktSetting = getModMandatory(ENUM_MOD_PARAMETER.GeneralSetting.UseMfgNoAsMktNo, generalData);
            setIsUseMfgNoAsMktno(mktSetting)
            setModSettingParams({
                Visibility: {
                    [RowsField.itemCode]: getModVisiblity(ENUM_MOD_PARAMETER.MemoEntry.Items, modData) ?? false,
                    [RowsField.lotNo]: getModVisiblity(ENUM_MOD_PARAMETER.MemoEntry.LotNo, modData) ?? false,
                    [RowsField.pktNo]: getModVisiblity(ENUM_MOD_PARAMETER.MemoEntry.PktNo, modData) ?? false,
                    [RowsField.shapeCode]: getModVisiblity(ENUM_MOD_PARAMETER.MemoEntry.Shape, modData) ?? false,
                    [RowsField.colorCode]: getModVisiblity(ENUM_MOD_PARAMETER.MemoEntry.Color, modData) ?? false,
                    [RowsField.purityCode]: getModVisiblity(ENUM_MOD_PARAMETER.MemoEntry.Purity, modData) ?? false,
                    [RowsField.sizeCode]: getModVisiblity(ENUM_MOD_PARAMETER.MemoEntry.Size, modData) ?? false,
                    [RowsField.reportNo]: getModVisiblity(ENUM_MOD_PARAMETER.MemoEntry.ReportNo, modData) ?? false,
                    [RowsField.lab]: getModVisiblity(ENUM_MOD_PARAMETER.MemoEntry.Lab, modData) ?? false,
                    [RowsField.lwRatio]: getModVisiblity(ENUM_MOD_PARAMETER.MemoEntry.LxWRatio, modData) ?? false,


                },
                Value: {
                    [RowsField.itemCode]: getModValue(ENUM_MOD_PARAMETER.MemoEntry.Items, modData) ?? false,
                    [RowsField.lotNo]: getModValue(ENUM_MOD_PARAMETER.MemoEntry.LotNo, modData) ?? false,
                    [RowsField.pktNo]: getModValue(ENUM_MOD_PARAMETER.MemoEntry.PktNo, modData) ?? false,
                    [RowsField.shapeCode]: getModValue(ENUM_MOD_PARAMETER.MemoEntry.Shape, modData) ?? false,
                    [RowsField.colorCode]: getModValue(ENUM_MOD_PARAMETER.MemoEntry.Color, modData) ?? false,
                    [RowsField.purityCode]: getModValue(ENUM_MOD_PARAMETER.MemoEntry.Purity, modData) ?? false,
                    [RowsField.sizeCode]: getModValue(ENUM_MOD_PARAMETER.MemoEntry.Size, modData) ?? false,
                    [RowsField.reportNo]: getModValue(ENUM_MOD_PARAMETER.MemoEntry.ReportNo, modData) ?? false,
                    [RowsField.lab]: getModValue(ENUM_MOD_PARAMETER.MemoEntry.Lab, modData) ?? false,
                    [RowsField.lwRatio]: getModValue(ENUM_MOD_PARAMETER.MemoEntry.LxWRatio, modData) ?? false,

                },



            })
        }

    }, [modSetting])

    const funCalBalPcs = (Pcs, retPcs, invPcs) => {
        let val = (Number(Pcs) - Number(retPcs) - Number(invPcs))
        return funCheckNumber(val)

    }

    const funCalBalWeight = (Weight, retWt, invWt) => {
        let val = (parseFloat(Weight) - parseFloat(retWt) - parseFloat(invWt))
        return funCheckNumber(val).toFixed(3)
    }


    if (memoParams && Object.keys(memoParams).length > 0) {
        if (detail && detail?.itemDetail && detail?.itemDetail?.length > 0) {
            const d = detail?.itemDetail.filter((ele) => ele.RefTrnId > 0)

            if (d && d.length > 0) {
                setIsNewEntry(false)
            }
            let t_bPcs = 0
            let t_bWeight = 0
            gridData = detail?.itemDetail.map((item, i) => {
                t_bPcs = selBillType == 'P' && selPktType == 'SNG' && item?.BWeight <= 0 ? 0 : funCalBalPcs(item?.Nos ?? 0, item?.Ret_Nos ?? 0, item?.Inv_Nos ?? 0)
                t_bWeight = selBillType == 'P' && selPktType == 'SNG' && item?.BWeight <= 0 ? 0 : funCalBalWeight(item?.Weight ?? 0, item?.Ret_Weight ?? 0, item?.Inv_Weight ?? 0)
                return {
                    id: ++i,
                    itemCode: item?.Item_Code ?? "",
                    itemDetail: item?.Item_Det ?? "",
                    pcs: item?.Nos ?? 0,
                    weight: item?.Weight ?? 0,
                    rate: item?.Rate ?? 0,
                    amount: item?.Amount ?? 0,
                    dRate: item?.S_Rate ?? 0,
                    convRate: item?.C_Rate ?? 0,
                    dAmount: item?.AmountD ?? 0,
                    detailId: item?.DetailId ?? 0,
                    refDetId: item?.DetailId ?? 0,
                    lotNo: item?.L_Code ?? "",
                    pktNo: item?.PktNo ?? "",
                    sLotNo: item?.SL_Code ?? "",
                    sPktNo: item?.SPktNo ?? "",
                    lwRatio: item?.Lw_Code ?? "",
                    shapeCode: item?.S_Code ?? "",
                    colorCode: item?.Sh_Code ?? "",
                    purityCode: item?.Q_Code ?? "",
                    sizeCode: item?.Sz_Code ?? "",
                    reportNo: item?.ReportNo ?? "",
                    lab: item?.Lab ?? "",
                    oldWeight: item?.OldRetWeight ?? 0,
                    oldPcs: item?.OldRetNos ?? 0,
                    bWeight: t_bWeight ?? 0,
                    bPcs: t_bPcs ?? 0,
                    isFinal: false,
                    isReturn: false,
                    retPcs: 0,// item?.Ret_Nos ?? 0,
                    retWeight: 0,// item?.Ret_Weight ?? 0,
                    finalPcs: 0,
                    finalWeight: 0,
                    finalRate: item?.Rate ?? 0,
                    dFinalRate: item?.S_Rate ?? 0,
                    newBalPcs: t_bPcs, //>// 0 ? funCalBalPcs(t_bPcs ?? 0, item?.Ret_Nos ?? 0, item?.Inv_Nos ?? 0) : 0,
                    newBalWeight: t_bWeight,// > 0 ? funCalBalWeight(t_bWeight ?? 0, item?.Ret_Weight ?? 0, item?.Inv_Weight ?? 0) : 0
                }
            })
        }
    }


    const formField = {
        transId: "transId",
        refTrnId: "refTrnId",
        vouNo: "vouNo",
        bookId: "bookId",
        partyId: "partyId",
        brokerId: "brokerId",
        challanNo: "challanNo",
        locationId: "locationId",
        challanDate: "challanDate",
        remark: "remark",
        pcs: "pcs",
        weight: "weight",
        tradeType: "tradeType"
    }

    const emptyFormField = Object.keys(formField).reduce((acc, key) => {
        if (key == formField.challanDate)
            acc[key] = new Date()
        else if (key == formField.netAmount || key == formField.pcs || key == formField.weight)
            acc[key] = 0
        else acc[key] = ""
        return acc
    }, {})

    const [rows, setRows] = useState([])

    const net_Amount = useMemo(
        () =>
            calculateTotal({
                data: rows,
                columnName: "amount",
            }),
        [rows]
    )

    const total_Weight = useMemo(
        () =>
            calculateTotal({
                data: rows,
                columnName: "weight",
            }),
        [rows]
    )
    const total_BalWeight = useMemo(
        () =>
            calculateTotal({
                data: rows,
                columnName: "bWeight",
            }),
        [rows]
    )
    const total_BalPcs = useMemo(
        () =>
            calculateTotal({
                data: rows,
                columnName: "bPcs",
            }),
        [rows]
    )
    const total_RetPcs = useMemo(
        () =>
            calculateTotal({
                data: rows,
                columnName: "retPcs",
            }),
        [rows]
    )
    const total_RetWeight = useMemo(
        () =>
            calculateTotal({
                data: rows,
                columnName: "retWeight",
            }),
        [rows]
    )
    const total_FinalPcs = useMemo(
        () =>
            calculateTotal({
                data: rows,
                columnName: "finalPcs",
            }),
        [rows]
    )
    const total_FinalWeight = useMemo(
        () =>
            calculateTotal({
                data: rows,
                columnName: "finalWeight",
            }),
        [rows]
    )
    const total_FinalRate = useMemo(
        () =>
            calculateTotal({
                data: rows,
                columnName: "finalRate",
            }),
        [rows]
    )
    const total_NewBalPcs = useMemo(
        () =>
            calculateTotal({
                data: rows,
                columnName: "newBalPcs",
            }),
        [rows]
    )
    const total_NewBalWeight = useMemo(
        () =>
            calculateTotal({
                data: rows,
                columnName: "newBalWeight",
            }),
        [rows]
    )
    const total_Rate = useMemo(
        () =>
            calculateTotal({
                data: rows,
                columnName: "rate",
            }),
        [rows]
    )
    const total_RateD = useMemo(
        () =>
            calculateTotal({
                data: rows,
                columnName: "dRate",
            }),
        [rows]
    )
    const net_AmountD = useMemo(
        () =>
            calculateTotal({
                data: rows,
                columnName: "dAmount",
            }),
        [rows]
    )
    const Final_Net_AmountD = useMemo(
        () =>
            calculateTotal({
                data: finalMemos,
                columnName: "dAmount",
            }),
        [finalMemos]
    )
    const Final_Net_Amount = useMemo(
        () =>
            calculateTotal({
                data: finalMemos,
                columnName: "amount",
            }),
        [finalMemos]
    )
    const getAvgRate = (type) => {
        let FinalData = []
        if (rows && rows.length > 0) {
            const filter = rows.filter((ele) => ele.isFinal == true)
            if (filter.length > 0) {
                setFinalMemos(filter)
                FinalData = filter
            }
        }

        const totalAmtD = calculateTotal({
            data: FinalData,
            columnName: "dAmount",
        })
        const totalAmt = calculateTotal({
            data: FinalData,
            columnName: "amount",
        })
        const totalWt = calculateTotal({
            data: FinalData,
            columnName: "weight",
        })
        if (type == "$")
            return (totalAmtD / totalWt).toFixed(2)
        else
            return (totalAmt / totalWt).toFixed(2)

    }
    const avg_RateD = useMemo(
        () => {
            return getAvgRate('$')
        },
        [rows]
    )
    const avg_Rate = useMemo(
        () => {
            return getAvgRate('Rs')
        },
        [rows]
    )
    console.log(rows)
    const total_Pcs = useMemo(
        () =>
            calculateTotal({
                data: rows,
                columnName: "pcs",
            }),
        [rows]
    )
    //console.log(rows)
    const RowsField = {
        detailId: "detailId",
        refDetId: "refDetId",
        id: "id",
        itemCode: "itemCode",
        itemDetail: "itemDetail",
        itemName: "itemName",
        shapeName: "shapeName",
        shapeCode: "shapeCode",
        pktNo: "pktNo",
        lotNo: "lotNo",
        sPktNo: "sPktNo",
        sLotNo: "sLotNo",
        purityName: "purityName",
        purityCode: "purityCode",
        colorName: "colorName",
        colorCode: "colorCode",
        sizeName: "sizeName",
        sizeCode: "sizeCode",
        lwRatio: "lwRatio",
        rate: "rate",
        amount: "amount",
        pcs: "pcs",
        weight: "weight",
        reportNo: "reportNo",
        lab: "lab",
        oldWeight: "oldWeight",
        oldPcs: "oldPcs",
        bPcs: "bPcs",
        bWeight: "bWeight",
        retPcs: "retPcs",
        retWeight: "retWeight",
        finalPcs: "finalPcs",
        finalWeight: "finalWeight",
        finalRate: "finalRate",
        dFinalRate: "dFinalRate",
        newBalPcs: "newBalPcs",
        newBalWeight: "newBalWeight",
        isFinal: "isFinal",
        billType: "billType",
        dRate: "dRate",
        dAmount: "dAmount",
        convRate: "convRate",
        isReturn: "isReturn"



    }
    const initialRow = {
        [RowsField.detailId]: 0,
        [RowsField.itemCode]: "",
        [RowsField.refDetId]: 0,
        [RowsField.itemName]: "",
        [RowsField.shapeName]: "",
        [RowsField.shapeCode]: "",
        [RowsField.pktNo]: "",
        [RowsField.lotNo]: "",
        [RowsField.sPktNo]: "",
        [RowsField.sLotNo]: "",
        [RowsField.purityName]: "",
        [RowsField.purityCode]: "",
        [RowsField.colorName]: "",
        [RowsField.colorCode]: "",
        [RowsField.sizeName]: "",
        [RowsField.sizeCode]: "",
        [RowsField.lwRatio]: "",
        [RowsField.rate]: 0,
        [RowsField.amount]: 0,
        [RowsField.pcs]: 0,
        [RowsField.weight]: 0,
        [RowsField.oldWeight]: 0,
        [RowsField.oldPcs]: 0,
        [RowsField.bPcs]: 0,
        [RowsField.bWeight]: 0,
        [RowsField.retPcs]: 0,
        [RowsField.retWeight]: 0,
        [RowsField.finalPcs]: 0,
        [RowsField.finalWeight]: 0,
        [RowsField.newBalPcs]: 0,
        [RowsField.newBalWeight]: 0,
        [RowsField.finalRate]: 0,
        [RowsField.dRate]: 0,
        [RowsField.dAmount]: 0,
        [RowsField.dFinalRate]: 0,
        [RowsField.convRate]: 0




    }

    const itemGridHeadClass = "bill-grid-style"
    const [formData, setFormData] = useState({
        ...emptyFormField
    })


    const inputBoxes = {
        Row1: [
            {
                id: formField.vouNo,
                name: formField.vouNo,
                placeholder: "Memo No.",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: true,
            },
            {
                id: formField.bookId,
                name: formField.bookId,
                placeholder: "Book Name",
                type: ENUM_INPUT_TYPE.autocomplete,
                size: "sm",
                label: "",
                data: masterData && masterData?.bookMaster ? masterData?.bookMaster : [],
                itemkey: "Party_Id",
                itemvalue: "Party_Name",
                isrequired: false,
            },

        ],

        Row2: [
            {
                id: formField.partyId,
                name: formField.partyId,
                placeholder: "Party Name",
                type: ENUM_INPUT_TYPE.autocomplete,
                size: "sm",
                label: "",
                data: masterData && masterData?.acMaster ? masterData?.acMaster : [],
                itemkey: "Party_Id",
                itemvalue: "Party_Name",
                isrequired: true,
            },
            {
                id: formField.brokerId,
                name: formField.brokerId,
                placeholder: "Broker",
                type: ENUM_INPUT_TYPE.autocomplete,
                size: "sm",
                label: "",
                data: masterData && masterData?.brokerMaster ? masterData?.brokerMaster : [],
                itemkey: "Party_Id",
                itemvalue: "Party_Name",
                isrequired: true,
            },
        ],
        Row3: [
            {
                id: formField.challanNo,
                name: formField.challanNo,
                placeholder: "Challan No.",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: true,
            },
            {
                id: formField.challanDate,
                name: formField.challanDate,
                placeholder: " Challan Date",
                type: ENUM_INPUT_TYPE.date,
                size: "sm",
                label: "",
                isrequired: true,
            },
        ],
        Row4: [
            {
                id: formField.tradeType,
                name: formField.tradeType,
                placeholder: "Trade Type",
                type: ENUM_INPUT_TYPE.autocomplete,
                size: "sm",
                label: "",
                data: ENUM_TRADE_TYPE,
                itemkey: "t_type",
                itemvalue: "t_type",
                isrequired: true,
            },
            {
                id: formField.locationId,
                name: formField.locationId,
                placeholder: "Location",
                type: ENUM_INPUT_TYPE.autocomplete,
                size: "sm",
                label: "",
                data: masterData && masterData?.locationMaster ? masterData?.locationMaster : [],
                itemkey: "Party_Id",
                itemvalue: "Party_Name",
                isrequired: true,
            },

        ],
        Rows5: [
            {
                id: formField.remark,
                name: formField.remark,
                placeholder: "Remark.",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,
            },
        ]


    }

    const hanldeBlur = (index, e) => {
        const { value, id } = e.target
        const newRows = [...rows]
        if (id == RowsField.retPcs) {
            if (value == 0 && parseFloat(newRows[index][RowsField.retWeight]) > 0) {
                newRows[index][RowsField.retPcs] = newRows[index][RowsField.bPcs]
                if (!toast.isActive("toast_chkretpcsZ")) {
                    toast.error(`Return Pcs should be greater than 0`, {
                        "position": "top-center",
                        "className": "toast-error",
                        toastId: "toast_chkretpcsZ"
                    })
                }
            }
            else if (Number(value) > Number(newRows[index][RowsField.bPcs])) {
                if (!toast.isActive("toast_chkretpcs")) {
                    toast.error(`Return Pcs should be less than ${newRows[index][RowsField.bPcs]}`, {
                        "position": "top-center",
                        "className": "toast-error",
                        toastId: "toast_chkretpcs"
                    })
                }
                newRows[index][RowsField.retPcs] = newRows[index][RowsField.bPcs]


            }
            const calData = funCalAllAmount(newRows, index, 0, 0)
            newRows[index].amount = calData.amount
            newRows[index].newBalPcs = calData.newBalPcs
            newRows[index].newBalWeight = calData.newBalWeight
            setRows(newRows)
        }
        else if (id == RowsField.retWeight) {
            if (value == 0 && Number(newRows[index][RowsField.retPcs]) > 0) {
                newRows[index][RowsField.retWeight] = newRows[index][RowsField.bWeight]
                if (!toast.isActive("toast_chkretpcsY")) {
                    toast.error(`Return Weight should be greater than 0`, {
                        "position": "top-center",
                        "className": "toast-error",
                        toastId: "toast_chkretpcsY"
                    })
                }
            }
            else if (parseFloat(value) > parseFloat(newRows[index][RowsField.bWeight])) {
                if (!toast.isActive("toast_chkretwt")) {
                    toast.error(`Return Weight should be less than ${newRows[index][RowsField.bWeight]}`, {
                        "position": "top-center",
                        "className": "toast-error",
                        toastId: "toast_chkretwt"
                    })
                }
                newRows[index][RowsField.retWeight] = newRows[index][RowsField.bWeight]

            }
            const calData = funCalAllAmount(newRows, index, 0, 0)
            newRows[index].amount = calData.amount
            newRows[index].newBalPcs = calData.newBalPcs
            newRows[index].newBalWeight = calData.newBalWeight
            setRows(newRows)
        }
    }

    const handleChange = (e) => {
        const { name, value } = e.target

        setFormData({ ...formData, [name]: value })
    }
    const handleAutoCompleteChange = (value, rowid, name) => {

    }
    const funSetTradeType = (partyId) => {
        if (partyId != "" && partyId != null) {
            let t_tradeType = formData.tradeType
            if (compState && compState?.trim() != "" && masterData && Object.keys(masterData).length > 0) {
                if (masterData?.acMaster.length > 0) {
                    const tempData = masterData.acMaster.filter((ele) => ele.Party_Id == partyId)

                    if (tempData && tempData?.length > 0) {
                        if (tempData[0]?.ADD_6.trim() != "") {
                            if (tempData[0]?.ADD_6.trim().toLowerCase() == compState?.trim().toLowerCase())
                                t_tradeType = "RD"
                            else
                                t_tradeType = "OGS"
                        }
                        else
                            t_tradeType = "URD"
                    }
                }
                // if (t_tradeT
                // }ype == "URD" || t_tradeType == "RD") setIsStPerDisable(false)
                // else setIsStPerDisable(true)
            }
            return t_tradeType
        }
        else
            return ""
    }
    const funCalAllAmount = (rowData, index, pcs, weight, currentID) => {

        let newRows = [...rows]
        if (rowData && rowData.length > 0)
            newRows = [...rowData]
        let t_Amount = 0
        let t_AmountD = 0
        let tempVal = 0
        let t_rate = newRows[index].rate && newRows[index].rate != null ? newRows[index].rate : 0
        let t_rateD = newRows[index].dRate && newRows[index].dRate != null ? newRows[index].dRate : 0
        let t_finalrate = newRows[index].finalRate && newRows[index].finalRate != null ? newRows[index].finalRate : 0
        //const t_pcs = pcs && pcs != null && pcs > 0 ? pcs : newRows[index].pcs ?? 0
        //const t_weight = weight && weight != null && weight != "" && weight > 0 ? weight : newRows[index].weight ?? 0
        const t_bpcs = newRows[index].bPcs ?? 0
        const t_retpcs = newRows[index].retPcs ?? 0
        const t_finalpcs = newRows[index].finalPcs ?? 0
        const t_bweight = newRows[index].bWeight ?? 0
        const t_retweight = newRows[index].retWeight ?? 0
        const t_finalweight = newRows[index].finalWeight ?? 0

        let t_dFinalRate = newRows[index].dFinalRate && newRows[index].dFinalRate != null ? newRows[index].dFinalRate : 0
        let conv_rate = newRows[index].convRate && newRows[index].convRate != null ? newRows[index].convRate : 0
        if (CurrencySetting != ENUM_CURRENCY_SETTING_VAL.RS) {
            if ((currentID == RowsField.dFinalRate || currentID == RowsField.convRate) && CurrencySetting == ENUM_CURRENCY_SETTING_VAL.Dollar) {
                tempVal = parseFloat(t_dFinalRate) * parseFloat(conv_rate)
                t_finalrate = funCheckNumber(tempVal).toFixed(2)
            }
            else if (currentID == RowsField.finalRate || currentID == RowsField.convRate) {
                tempVal = parseFloat(t_finalrate) / parseFloat(conv_rate)
                t_dFinalRate = funCheckNumber(tempVal).toFixed(2)
            }
        }
        tempVal = funCalBalPcs(t_bpcs, t_retpcs, t_finalpcs);
        let t_newBalPcs = funCheckNumber(tempVal)
        tempVal = funCalBalWeight(t_bweight, t_retweight, t_finalweight);

        let t_newBalWeight = tempVal ? parseFloat(tempVal).toFixed(3) : 0
        if (newRows[index].isFinal) {
            tempVal = parseFloat(t_finalrate > 0 ? t_finalrate : t_rate) * parseFloat(t_finalweight)
            t_Amount = funCheckNumber(tempVal)
            tempVal = parseFloat(t_dFinalRate > 0 ? t_dFinalRate : t_rateD) * parseFloat(t_finalweight)
            t_AmountD = funCheckNumber(tempVal)
        }
        else {
            tempVal = parseFloat(t_rate) * parseFloat(t_retweight)
            t_Amount = funCheckNumber(tempVal)
            tempVal = parseFloat(t_rateD) * parseFloat(t_retweight)
            t_AmountD = funCheckNumber(tempVal)
        }

        //t_Amount = funCheckNumber(tempVal)
        return { amount: t_Amount.toFixed(2), dAmount: t_AmountD.toFixed(2), newBalPcs: t_newBalPcs, newBalWeight: t_newBalWeight, finalRate: t_finalrate, dFinalRate: t_dFinalRate }

    }
    // end delete row from dynamic grid
    const handleInputChange = (rowId, e, name) => {

        let { value, id } = e.target
        let index = rows.findIndex(ele => ele.id == rowId)
        const newRows = [...rows]
        setSelectedGridRowId(index)

        newRows[index][id] = value

        if (id == RowsField.finalRate ||
            id == RowsField.finalWeight ||
            id == RowsField.retWeight ||
            id == RowsField.retPcs ||
            id == RowsField.finalPcs ||
            id == RowsField.convRate ||
            id == RowsField.dFinalRate
        ) {

            const calData = funCalAllAmount(newRows, index, 0, 0, id)
            newRows[index].amount = calData.amount
            newRows[index].dAmount = calData.dAmount
            newRows[index].newBalPcs = calData.newBalPcs
            newRows[index].newBalWeight = calData.newBalWeight
            if (CurrencySetting != ENUM_CURRENCY_SETTING_VAL.RS) {
                if (id != RowsField.dFinalRate)
                    newRows[index].dFinalRate = calData.dFinalRate //.toFixed(2)
                if (id != RowsField.finalRate)
                    newRows[index].finalRate = calData.finalRate //.toFixed(2)
            }
        }

        setRows(newRows)
    }
    const funSetAction = (index, rowData, name, value) => {
        // let index = rows.findIndex(ele => ele.id == rowId)
        const newRows = [...rowData]
        let setPcsColumn = ""
        let setWeightColumn = ""

        if (name == RowsField.isFinal) {
            if (value == true) {
                newRows[index][RowsField.isReturn] = false
                setWeightColumn = RowsField.finalWeight
                setPcsColumn = RowsField.finalPcs
                newRows[index][RowsField.retPcs] = 0
                newRows[index][RowsField.retWeight] = 0
            }
            else {
                newRows[index][RowsField.finalPcs] = 0
                newRows[index][RowsField.finalWeight] = 0
            }
        }
        else if (name == RowsField.isReturn) {
            if (value == true) {
                newRows[index][RowsField.isFinal] = false
                setWeightColumn = RowsField.retWeight
                setPcsColumn = RowsField.retPcs
                newRows[index][RowsField.finalWeight] = 0
                newRows[index][RowsField.finalPcs] = 0
                newRows[index][RowsField.finalRate] = newRows[index][RowsField.rate]
                newRows[index][RowsField.dFinalRate] = newRows[index][RowsField.dRate]

            }
            else {
                newRows[index][RowsField.retPcs] = 0
                newRows[index][RowsField.retWeight] = 0
            }
        }

        newRows[index][name] = value
        newRows[index][setPcsColumn] = newRows[index][RowsField.bPcs]
        newRows[index][setWeightColumn] = newRows[index][RowsField.bWeight]
        const calData = funCalAllAmount(newRows, index, 0, 0)
        newRows[index].amount = calData.amount
        newRows[index].newBalPcs = calData.newBalPcs
        newRows[index].newBalWeight = calData.newBalWeight
        setRows(newRows)
    }
    const AvgRate = useMemo(() => {

    }, [rows])
    const handleCheckChange = (rowId, value, name) => {

        let index = rows.findIndex(ele => ele.id == rowId)
        //const newRows = [...rows]
        setSelectedGridRowId(index)
        funSetAction(index, rows, name, value)
        // let setPcsColumn = ""
        // let setWeightColumn = ""
        // setSelectedGridRowId(index)
        // if (name == RowsField.isFinal) {
        //     if (value == true) {
        //         newRows[index][RowsField.isReturn] = false
        //         setWeightColumn = RowsField.finalWeight
        //         setPcsColumn = RowsField.finalPcs
        //         newRows[index][RowsField.retPcs] = 0
        //         newRows[index][RowsField.retWeight] = 0
        //     }
        //     else {
        //         newRows[index][RowsField.finalPcs] = 0
        //         newRows[index][RowsField.finalWeight] = 0
        //     }
        // }
        // else if (name == RowsField.isReturn) {
        //     if (value == true) {
        //         newRows[index][RowsField.isFinal] = false
        //         setWeightColumn = RowsField.retWeight
        //         setPcsColumn = RowsField.retPcs
        //         newRows[index][RowsField.finalWeight] = 0
        //         newRows[index][RowsField.finalPcs] = 0
        //         newRows[index][RowsField.finalRate] = newRows[index][RowsField.rate]
        //         newRows[index][RowsField.dFinalRate] = newRows[index][RowsField.dRate]

        //     }
        //     else {
        //         newRows[index][RowsField.retPcs] = 0
        //         newRows[index][RowsField.retWeight] = 0
        //     }
        // }

        // newRows[index][name] = value
        // newRows[index][setPcsColumn] = newRows[index][RowsField.bPcs]
        // newRows[index][setWeightColumn] = newRows[index][RowsField.bWeight]
        // const calData = funCalAllAmount(newRows, index, 0, 0)
        // newRows[index].amount = calData.amount
        // newRows[index].newBalPcs = calData.newBalPcs
        // newRows[index].newBalWeight = calData.newBalWeight
        // setRows(newRows)
    }
    const funIsFooter = (id) => {
        if (id == 1000000)
            return true
        else
            return false
    }


    const renderInputCell = (row, input_id, input_type, is_readonly, holder_text, is_required, variant, color) => {

        return (
            <Input
                isRequired={is_required}
                id={RowsField[input_id]}
                name={RowsField[input_id]}
                type={input_type}
                size="sm"
                // label=""
                labelPlacement="outside"
                readOnly={is_readonly}
                disabled={is_readonly}
                placeholder={holder_text}
                //allow space in text box
                onBlur={(e) => hanldeBlur(row.id - 1, e)}
                onKeyDown={(event) => {
                    if (['Space', 'ArrowLeft', 'ArrowRight'].includes(event.code)) {
                        return; // Do nothing
                    } else {
                        event.stopPropagation(); // Prevent other keys from propagating
                    }
                }}
                defaultValue=""
                value={row[input_id]}
                onChange={(e) => handleInputChange(row.id, e, "")}
                className="max-w-xs mt-1"
                classNames={{
                    "input": `${input_type == "number" ? "text-right" : ""}  text-xs `,

                }}
                variant={variant ? variant : "bordered"}
                color={color ? color : ""}

            ></Input>
        )
    }
    const setColumnRequired = (column) => {
        return false
    }
    const setColumnDisable = () => {
        return true
    }
    const handleHeaderCheckChange = (value, name) => {
        if (name == RowsField.isFinal) {
            setChkGridSelAllFinal(value)
            setChkGridSelAllReturn(false)
        }
        else {
            setChkGridSelAllReturn(value)
            setChkGridSelAllFinal(false)
        }
        const newData = [...rows]
        newData.forEach((item, index) => {
            if (item?.bWeight > 0) {
                funSetAction(index, newData, name, value)
            }

        })
        // const upData = rows.map((ele) => {
        //     if (ele.bWeight > 0)
        //         return name == RowsField.isFinal ? {
        //             ...ele, [name]: value, [RowsField.isReturn]: false
        //         } : {
        //             ...ele, [name]: value, [RowsField.isFinal]: false
        //         }
        //     else
        //         return ele
        // })
        // setRows(upData)

    }

    const setColumnVisiblity = (column) => {
        if (modSetting && Object.keys(modSetting).length > 0)
            return modSettingParams && Object.keys(modSettingParams).length > 0 ? modSettingParams?.Visibility[column] : true
        else
            return true
    }
    const setCurrencyColumnVisiblity = (column) => {
        const RsCol = [RowsField.rate, RowsField.amount, RowsField.finalRate]
        const DCol = [RowsField.dRate, RowsField.dAmount, RowsField.dFinalRate]
        if (CurrencySetting == ENUM_CURRENCY_SETTING_VAL.RS && RsCol.includes(column))
            return true
        else if (CurrencySetting == ENUM_CURRENCY_SETTING_VAL.Dollar && DCol.includes(column))
            return true
        else if (CurrencySetting == ENUM_CURRENCY_SETTING_VAL.DUAL)
            return true
        else
            return false
    }
    const columns = [
        {
            field: RowsField.id,
            headerName: "Sr.No",
            width: 60,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,

            renderCell: ({ row }) => (
                <div>
                    {funIsFooter(row.id) ? <div className="text-center"> Total</div> :
                        <div className="flex justify-evenly" ><h6> {row.id}</h6>

                        </div>}
                </div>
            ),
        },
        {
            field: RowsField.lotNo,
            headerName: "Lot No",
            minWidth: 80,
            flex: 1,
            align: "center",
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (

                <div>{funIsFooter(row.id) ? "" :
                    row.lotNo
                }</div>

            ),
        },
        {
            field: RowsField.pktNo,
            headerName: "Pkt No",
            minWidth: 80,
            flex: 1,
            align: "center",
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <div>{
                    funIsFooter(row.id) ? "" :
                        row.pktNo
                }</div>
            )
        },
        {
            field: RowsField.pcs,
            headerName: "Memo Pcs",
            minWidth: 120,
            flex: 1,
            headerAlign: "center",
            type: "number",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <div>{funIsFooter(row.id) ? <div className="text-right" >{total_Pcs}</div> :
                    renderInputCell(row, RowsField.pcs, "number",
                        setColumnDisable(row),
                        "", true, "", "")
                }</div>
            )

        },
        {
            field: RowsField.weight,
            headerName: "Memo Weight",
            minWidth: 120,
            flex: 1,
            type: "number",
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <div>{funIsFooter(row.id) ? <div className="text-right">{total_Weight}</div>
                    : renderInputCell(row, RowsField.weight, "number",
                        setColumnDisable(row),
                        "", true, "", "")
                }</div>
            )
        },
        {
            field: RowsField.bPcs,
            headerName: "Bal. Pcs",
            minWidth: 120,
            flex: 1,
            headerAlign: "center",
            type: "number",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <div>{funIsFooter(row.id) ? <div className="text-right" >{total_BalPcs}</div> :
                    renderInputCell(row, RowsField.bPcs, "number",
                        true,
                        "", true, "", "")
                }</div>
            )

        },
        {
            field: RowsField.bWeight,
            headerName: "Bal. Weight",
            minWidth: 120,
            flex: 1,
            type: "number",
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <div>{funIsFooter(row.id) ? <div className="text-right">{total_BalWeight}</div>
                    : renderInputCell(row, RowsField.bWeight, "number",
                        true,
                        "", true, "", "")
                }</div>
            )
        },
        {
            field: RowsField.isFinal,
            headerName: "Final",
            minWidth: 70,
            flex: 1,
            align: "center",
            headerAlign: "center",

            headerClassName: itemGridHeadClass,
            renderHeader: (params) => (
                <div className="text-center">
                    <div>Final</div>
                    <Checkbox size="sm" isSelected={chkGridSelAllFinal} onValueChange={(e) => handleHeaderCheckChange(e, RowsField.isFinal)} color="success"></Checkbox>
                </div>
            ),
            renderCell: ({ row }) => (
                <div>{funIsFooter(row.id) ? ""
                    : <Checkbox isDisabled={row.isReturn || row.bWeight <= 0 ? true : false} isSelected={row.isFinal} onValueChange={(e) => handleCheckChange(row.id, e, RowsField.isFinal)} color="success"></Checkbox>
                }</div>
            )
        },
        {
            field: RowsField.isReturn,
            headerName: "Return",
            minWidth: 80,
            flex: 1,
            align: "center",
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderHeader: (params) => (
                <div className="text-center">
                    <div>Return</div>
                    <Checkbox size="sm" isSelected={chkGridSelAllReturn} onValueChange={(e) => handleHeaderCheckChange(e, RowsField.isReturn)} color="danger"></Checkbox>
                </div>
            ),
            renderCell: ({ row }) => (
                <div>{funIsFooter(row.id) ? ""
                    : <Checkbox isDisabled={row.isFinal || row.bWeight <= 0 ? true : false} isSelected={row.isReturn} onValueChange={(e) => handleCheckChange(row.id, e, RowsField.isReturn)} color="danger"></Checkbox>
                }</div>
            )
        },
        {
            field: RowsField.retPcs,
            headerName: "Return Pcs",
            minWidth: 120,
            flex: 1,
            headerAlign: "center",
            type: "number",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <div>{funIsFooter(row.id) ? <div className="text-right" >{total_RetPcs}</div> :
                    renderInputCell(row, RowsField.retPcs, "number",
                        row.isReturn ? false : true,
                        "", true, "", "")
                }</div>
            )

        },
        {
            field: RowsField.retWeight,
            headerName: "Return. Weight",
            minWidth: 120,
            flex: 1,
            headerAlign: "center",
            type: "number",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <div>{funIsFooter(row.id) ? <div className="text-right">{total_RetWeight}</div>
                    : renderInputCell(row, RowsField.retWeight, "number",
                        row.isReturn ? false : true,
                        "", true, "", "")
                }</div>
            )
        },
        {
            field: RowsField.finalPcs,
            headerName: "Final Pcs",
            minWidth: 120,
            flex: 1,
            headerAlign: "center",
            type: "number",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <div>{funIsFooter(row.id) ? <div className="text-right" >{total_FinalPcs}</div> :
                    renderInputCell(row, RowsField.finalPcs, "number",
                        true,
                        "", true, "", "")
                }</div>
            )

        },
        {
            field: RowsField.finalWeight,
            headerName: "Final Weight",
            minWidth: 120,
            flex: 1,
            headerAlign: "center",
            type: "number",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <div>{funIsFooter(row.id) ? <div className="text-right">{total_FinalWeight}</div>
                    : renderInputCell(row, RowsField.finalWeight, "number",
                        true,
                        "", true, "", "")
                }</div>
            )
        },
        {
            field: RowsField.convRate,
            headerName: "Conv. Rate",
            minWidth: 120,
            flex: 1,
            headerAlign: "center",
            align: "right",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (<div>{funIsFooter(row.id) ? <div className="text-right" >{ }</div> :
                renderInputCell(row, RowsField.convRate, "number",
                    row.bWeight <= 0 || row.isReturn ? true : false,
                    "", false, "", "")
            }</div>
            )
        },
        {
            field: RowsField.finalRate,
            headerName: "Final Rate",
            minWidth: 120,
            flex: 1,
            type: "number",
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <div>{funIsFooter(row.id) ? <div className="text-right" >{total_FinalRate}</div> :
                    renderInputCell(row, RowsField.finalRate, "number",
                        row.bWeight <= 0 || row.isReturn ? true : false,
                        "", false, "", "")
                }</div>
            )

        },
        {
            field: RowsField.dFinalRate,
            headerName: "Final Rate($)",
            minWidth: 120,
            flex: 1,
            type: "number",
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <div>{funIsFooter(row.id) ? <div className="text-right" >{total_FinalRate}</div> :
                    renderInputCell(row, RowsField.dFinalRate, "number",
                        CurrencySetting == ENUM_CURRENCY_SETTING_VAL.Dollar ? row.bWeight <= 0 || row.isReturn ? true : false : true,
                        "", false, "", "")
                }</div>
            )

        },
        {
            field: RowsField.newBalPcs,
            headerName: "New Bal. Pcs",
            minWidth: 120,
            flex: 1,
            type: "number",
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <div>{funIsFooter(row.id) ? <div className="text-right" >{total_NewBalPcs}</div> :
                    renderInputCell(row, RowsField.newBalPcs, "number",
                        true,
                        "", true, "", "")
                }</div>
            )

        },
        {
            field: RowsField.newBalWeight,
            headerName: "New Bal. Weight",
            minWidth: 120,
            flex: 1,
            type: "number",
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <div>{funIsFooter(row.id) ? <div className="text-right">{total_NewBalWeight}</div>
                    : renderInputCell(row, RowsField.newBalWeight, "number",
                        true,
                        "", true, "", "")
                }</div>
            )
        },
        {
            field: RowsField.itemCode,
            headerName: "Item Code",
            minWidth: 80,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (<div>

                {funIsFooter(row.id) ? "" : row.itemCode}
            </div>)

        },
        {
            field: RowsField.itemName,
            headerName: "Item Name",
            minWidth: 300,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <div className="mt-1 flex items-start">
                    {funIsFooter(row.id) ? "" :
                        <Autocomplete
                            isRequired={setColumnRequired(RowsField.itemCode)}
                            size="sm"
                            color={"danger"}
                            id={RowsField.itemName}
                            eventResizeFeature={true}
                            selectionMode="single"
                            showScrollIndicators={true}
                            placeholder="--Select--"
                            className="max-w-23 text-xs"

                            menuTrigger={"input"}
                            isClearable={false}
                            isLoading={isLoadingData}
                            isReadOnly={true}
                            isVirtualized
                            defaultItems={
                                masterData && masterData.itemMaster ? masterData?.itemMaster : []
                            }
                            onSelectionChange={(e) =>
                                handleAutoCompleteChange(e, row.id, RowsField.itemName)
                            }
                            //onChange={handleFormSelectionChange}
                            selectedKey={row.itemCode}
                        >
                            {(item) => (
                                <AutocompleteItem
                                    key={item.Item_Code}
                                >
                                    {item.Item_Code + "(" + item.Item_Desc + ")"}
                                </AutocompleteItem>
                            )}
                        </Autocomplete>
                    }

                </div>
            ),
        },

        {
            field: RowsField.shapeName,
            headerName: "Shape",
            minWidth: 150,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <div className="mt-1 flex items-start">
                    {funIsFooter(row.id) ? "" :
                        <Autocomplete
                            isRequired={setColumnRequired(RowsField.shapeCode)}
                            size="sm"
                            color={"warning"}
                            id={RowsField.shapeName}
                            eventResizeFeature={true}
                            selectionMode="single"
                            showScrollIndicators={true}
                            placeholder="--Select--"
                            className="max-w-23"
                            menuTrigger={"input"}
                            isReadOnly={true}
                            isClearable={false}
                            isLoading={isLoadingGridData}
                            isVirtualized
                            defaultItems={
                                gridMasterData && gridMasterData.shapeMaster ? gridMasterData?.shapeMaster : []
                            }
                            onSelectionChange={(e) =>
                                handleAutoCompleteChange(e, row.id, RowsField.shapeName)
                            }
                            selectedKey={row.shapeCode}
                        >
                            {(item) => (
                                <AutocompleteItem
                                    key={item.S_Code}
                                >
                                    {item.S_Code + "(" + item.S_Name + ")"}
                                </AutocompleteItem>
                            )}
                        </Autocomplete>
                    }


                </div>
            ),
        },

        {
            field: RowsField.colorName,
            headerName: "Color",
            minWidth: 150,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <div className="mt-1 flex items-start">
                    {funIsFooter(row.id) ? "" :
                        <Autocomplete
                            isRequired={setColumnRequired(RowsField.colorCode)}
                            size="sm"
                            color={"success"}
                            id={RowsField.colorName}
                            eventResizeFeature={true}
                            selectionMode="single"
                            showScrollIndicators={true}
                            placeholder="--Select--"
                            className="max-w-23"
                            menuTrigger={"input"}
                            isClearable={false}
                            isLoading={isLoadingGridData}
                            isReadOnly={true}
                            isVirtualized
                            defaultItems={
                                gridMasterData && gridMasterData.colorMaster ? gridMasterData?.colorMaster : []
                            }
                            onSelectionChange={(e) =>
                                handleAutoCompleteChange(e, row.id, RowsField.colorName)
                            }
                            selectedKey={row.colorCode}
                        >
                            {(item) => (
                                <AutocompleteItem
                                    key={item.Sh_Code}
                                >
                                    {item.Sh_Code + "(" + item.Sh_Name + ")"}
                                </AutocompleteItem>
                            )}
                        </Autocomplete>}


                </div>
            ),
        },

        {
            field: RowsField.purityName,
            headerName: "Purity",
            minWidth: 150,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <div className="mt-1 flex items-start">
                    {funIsFooter(row.id) ? "" :
                        <Autocomplete
                            isRequired={setColumnRequired(RowsField.purityCode)}
                            size="sm"
                            color={"primary"}
                            id={RowsField.purityName}
                            eventResizeFeature={true}
                            selectionMode="single"
                            showScrollIndicators={true}
                            placeholder="--Select--"
                            className="max-w-23"
                            menuTrigger={"input"}
                            isClearable={false}
                            isLoading={isLoadingGridData}
                            isReadOnly={true}
                            isVirtualized
                            defaultItems={
                                gridMasterData && gridMasterData.purityMaster ? gridMasterData?.purityMaster : []
                            }
                            onSelectionChange={(e) =>
                                handleAutoCompleteChange(e, row.id, RowsField.purityName)
                            }
                            selectedKey={row.purityCode}
                        >
                            {(item) => (
                                <AutocompleteItem
                                    key={item.Q_Code}
                                >
                                    {item.Q_Code + "(" + item.Q_Name + ")"}
                                </AutocompleteItem>
                            )}
                        </Autocomplete>
                    }


                </div>
            ),
        },

        {
            field: RowsField.sizeName,
            headerName: "Size",
            minWidth: 150,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <div className="mt-1 flex items-start">
                    {funIsFooter(row.id) ? "" :
                        <Autocomplete
                            isRequired={setColumnRequired(RowsField.sizeCode)}
                            size="sm"
                            color={"default"}
                            id={RowsField.sizeName}
                            eventResizeFeature={true}
                            selectionMode="single"
                            showScrollIndicators={true}
                            placeholder="--Select--"
                            className="max-w-23"
                            menuTrigger={"input"}
                            isClearable={false}
                            isLoading={isLoadingGridData}
                            isReadOnly={true}
                            isVirtualized
                            defaultItems={
                                gridMasterData && gridMasterData.sizeMaster ? gridMasterData?.sizeMaster : []
                            }
                            onSelectionChange={(e) =>
                                handleAutoCompleteChange(e, row.id, RowsField.sizeName)
                            }
                            selectedKey={row.sizeCode}
                        >
                            {(item) => (
                                <AutocompleteItem
                                    key={item.Sz_Code}
                                >
                                    {item.Sz_Name}
                                </AutocompleteItem>
                            )}
                        </Autocomplete>
                    }


                </div>
            ),
        },

        {
            field: RowsField.lwRatio,
            headerName: "LxW Ratio",
            minWidth: 120,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <div>
                    {
                        funIsFooter(row.id) ? "" : row.lwRatio
                    }</div>
            )
        },
        {
            field: RowsField.reportNo,
            headerName: "Report No.",
            minWidth: 100,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <div>{funIsFooter(row.id) ? "" : row.reportNo
                }</div>
            )
        },
        {
            field: RowsField.lab,
            headerName: "Lab",
            minWidth: 100,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <div>{funIsFooter(row.id) ? "" : row.lab
                }</div>
            )
        },

        {
            field: RowsField.rate,
            headerName: "Rate",
            minWidth: 120,
            flex: 1,
            headerAlign: "center",
            align: "right",
            type: "number",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (<div>{funIsFooter(row.id) ?
                <div className="text-right"> {total_Rate}</div> :
                row.rate
            }</div>
            )
        },
        {
            field: RowsField.dRate,
            headerName: "Rate($)",
            minWidth: 120,
            flex: 1,
            headerAlign: "center",
            type: "number",
            align: "right",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (<div>{funIsFooter(row.id) ?
                <div className="text-right"> {total_RateD}</div> :
                row.dRate
            }</div>
            )
        },
        {
            field: RowsField.amount,
            headerName: "Amount",
            minWidth: 130,
            flex: 1,
            type: "number",
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            align: "right",
            renderCell: ({ row }) =>
            (
                <div>
                    {funIsFooter(row.id) ? <div className="text-right">{net_Amount}</div> : row[RowsField.amount]
                    }
                </div>)
        },
        {
            field: RowsField.dAmount,
            headerName: "Amount($)",
            minWidth: 120,
            flex: 1,
            type: "number",
            headerAlign: "center",
            align: "right",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (<div>{funIsFooter(row.id) ?
                <div className="text-right"> {net_AmountD}</div> :
                row.dAmount
            }</div>
            )
        },

    ]
    const [errors, setErrors] = useState({})



    const validateForm = () => {
        const newErrors = {}

        // Validate username
        if (formData.vouNo.trim() == "") {
            newErrors[formField.vouNo] = "Memo No required"
        }

        if (formData[formField.partyId] == "" || formData[formField.partyId] == "0") {
            newErrors[formField.partyId] = "Party Name required"
        }
        if (formData[formField.bookId] == "" || formData[formField.bookId] == "0") {
            newErrors[formField.bookId] = "Book Name required"
        }

        if (formData.challanNo.trim() == "") {
            newErrors[formField.challanNo] = "Challan No required"
        }
        if (formData[formField.challanDate] == null || formData[formField.challanDate] == "" || formData[formField.challanDate] == "Invalid Date") {
            newErrors[formField.challanDate] = "Challan Date required"
        }



        setErrors(newErrors)

        // Return true if there are no errors
        return Object.keys(newErrors).length === 0
    }

    useEffect(() => {
        validateForm();
    }, [formData])

    const isDisableSubmit = () => {
        if (memoParams && Object.keys(memoParams).length > 0) {
            const { status } = memoParams
            if (status == ENUM_STATUS.Final)
                return true
            else
                return false
        }
    }

    const ValidateGrid = () => {
        let no = 0
        let msg = ""

        if (rows.length > 0) {
            for (let i = 0; i < rows.length; i++) {
                // if (rows[i].id != 100) {
                //  if (!rows[i].isFinal || !rows[i].isReturn) {
                //      if (!msg.includes("Final/Return"))
                //          msg = msg + "  Final/Return ,";
                //      no = 2
                // }
                if (rows[i].isFinal && (rows[i].finalWeight == "0" || rows[i].finalWeight == ""
                    //|| rows[i].finalPcs == "0" || rows[i].finalPcs == ""
                )) {
                    if (!msg.includes("Final Weight"))
                        msg = msg + "  Final Weight ,";
                    no = 1
                }
                if (rows[i].isReturn && (rows[i].retWeight == "0" || rows[i].retWeight == ""
                    // || rows[i].retPcs == "0" || rows[i].retPcs == ""
                )) {
                    if (!msg.includes("Return Weight"))
                        msg = msg + "  Return Weight ,";
                    no = 1
                }
                //}
            }
        }
        else {
            msg = "Add Atleast One  Item"
            no = 1
        }
        if (no == 1)
            return msg + " is required"
        else return ""
    }
    const getEntryBillType = (isReturn) => {
        if (isReturn) { return selBillType == 'P' ? 'N' : selBillType == 'S' ? 'T' : '' }
        else { return selBillType }
    }

    const handleSubmit = (e) => {
        e.preventDefault()


        //const newRows = rows.filter(ele => ele.id != 100)
        const validate_form = validateForm()
        const grid_msg = ValidateGrid()
        if (grid_msg != "" || !validate_form) {
            show(grid_msg)
            return;
        }

        const rowData = rows.filter((ele) => ele.isFinal || ele.isReturn)
        if (rowData && rowData.length <= 0) {
            show("Select At Least One Final/Return Action");
            return;
        }
        if (submitLockRef.current) return;
        submitLockRef.current = true;
        //  if (grid_msg == "" && validate_form) {
        funAddUpdate({
            data: {
                comp_code: compCode.join(","),
                item_list: rowData,
                deleteditem_list: [],
                trans_id: formData[formField.transId],
                ref_trn: formData[formField.transId],
                bill_type: selBillType,
                trade_of: selTradeOf,
                with_bill: 0,
                trade_type: formData[formField.tradeType],
                nos: 0,
                weight: 0,
                vou_no: formData[formField.vouNo],
                book_id: formData[formField.bookId],
                party_id: formData[formField.partyId],
                location_id: formData[formField.locationId],
                pkt_type: selPktType == 'SNG' ? selPktType : '',
                broker_id: formData[formField.brokerId],
                challan_no: formData[formField.challanNo],
                challan_date: formData[formField.challanDate],
                remark: formData[formField.remark],
                net_amount: net_Amount,
                net_amountd: net_AmountD,
                mkt_lotno: isUseMfgNoAsMktno ? '0' : "1",
                login_userid: user.username,
                rec_status: 2,
                fystart_date: dayjs(startDate).format("YYYY-MM-DD"),
                fyend_date: dayjs(endDate).format("YYYY-MM-DD")
            }
        })
        //}
        // else {
        //     addToast({
        //         title: "",
        //         description: grid_msg,
        //         color: "danger"
        //     })

        // }
    }

    useEffect(() => {
        if (memoParams && Object.keys(memoParams)?.length > 0) {
            //const newData = [...gridData, { id: 100, ...initialRow }].sort((a, b) => a.id - b.id)

            setRows(gridData)
            if (detail &&
                detail?.itemData &&
                detail?.itemData.length > 0) {
                if (detail?.itemData[0]?.RefTrnId && detail?.itemData[0]?.RefTrnId != null && detail?.itemData[0]?.RefTrnId > 0) {
                    setIsNewEntry(false)
                }
                setFormData({
                    ...formData,
                    [formField.transId]: detail?.itemData[0]?.TransactionId ?? "",
                    [formField.vouNo]: detail?.itemData[0]?.Vou_No ?? "",
                    [formField.bookId]: detail?.itemData[0]?.Ac_Id ?? "",
                    [formField.brokerId]: detail?.itemData[0]?.Br_Id ?? "",
                    [formField.partyId]: detail?.itemData[0]?.Pac_Id ?? "",
                    [formField.locationId]: detail?.itemData[0]?.Lac_Id ?? "",
                    [formField.challanNo]: detail?.itemData[0]?.Chal_No ?? "",
                    [formField.challanDate]: detail?.itemData[0]?.Chal_Date ?? "",
                    [formField.remark]: detail?.itemData[0]?.Remark ?? "",
                    [formField.pcs]: detail?.itemData[0]?.Pcs ?? "",
                    [formField.weight]: detail?.itemData[0]?.Weight ?? "",
                    [formField.tradeType]: funSetTradeType(detail?.itemData[0]?.Pac_Id ?? ""),

                })

            }
        }

    }, [detail, masterData])
    const funGetMasterLink = () => {
        if (selPktType == 'MIX')
            return naviCode + btype + "/" + trdtype + "/" + ptype + linksUrl.mixEntry + linksUrl.memoEntry.memoEntryMaster
        else
            return naviCode + btype + "/" + trdtype + "/" + ptype + linksUrl.memoEntry.memoEntryMaster
    }
    const handleClickPrev = () => {
        navigate(funGetMasterLink())
    }

    const handleAddRow = () => {
        let new_initialRow = initialRow
        if (modSettingParams && modSettingParams.Visibility) {

            if (Object.keys(modSettingParams.Visibility).length > 0) {
                //set default value to hidden grid column setting based
                const hiddenCol = Object.entries(modSettingParams.Visibility)
                    .filter(([key, value]) => value == false) // filter where value is true
                    .map(([key, value]) => {
                        return { [key]: modSettingParams.Value[key] }
                    });

                const result = hiddenCol.reduce((acc, current) => {
                    return { ...acc, ...current };
                }, {});

                if (result && Object.keys(result).length > 0)
                    new_initialRow = { ...initialRow, ...result }
            }

        }
        const newRow = { id: rows.length + 1, ...new_initialRow, }
        setRows([...rows, newRow])

    }
    const handleNewAcEntry = () => {
        let redLink = naviCode + btype + "/" + trdtype + "/" + ptype + linksUrl.memoEntry.createMemoEntry
        if (selPktType == 'MIX')
            redLink = naviCode + btype + "/" + trdtype + "/" + ptype + linksUrl.mixEntry + linksUrl.memoEntry.createMemoEntry
        dispatch(setRedirectLink(redLink))
        navigate(linksUrl.master.account.createAccountMaster)
    }
    const funGetLotNPktNoByStockID = (stockID = "") => {
        const resultData = { l_code: "", pktno: "" };

        const showToast = (id, msg) => {
            show(msg)
            // if (toast && !toast.isActive(id)) {
            //     toast.error(msg, {
            //         position: "top-center",
            //         className: "toast-error",
            //         toastId: id,
            //     });
            // }
        };

        const resetFileInput = () => {
            if (fileInputRef.current) {
                fileInputRef.current.value = '';
            }
        };

        if (!stockID.trim()) {
            return resultData;
        }

        const [lotNo, pktNo] = stockID.split('-');

        if (lotNo && pktNo) {
            resultData.l_code = lotNo.trim();
            resultData.pktno = pktNo.trim();
        } else {
            showToast("stkinval", "Invalid StockID Format: LotNo & PktNo must be separated by ' - '");
            resetFileInput();
        }

        if (!resultData.l_code || !resultData.pktno) {
            showToast("stkinkval", "StockID not found or invalid format");
            resetFileInput();
        }

        return resultData;
    };
    const transformExcelData = (excelRows, excelColMapping) => {
        return excelRows.map(row => {
            const rowObj = {};

            excelColMapping.forEach(mapping => {
                const colIndex = parseInt(mapping.xl_col_no) - 1; // Convert to 0-based index
                rowObj[mapping.tb_col_name] = row[colIndex] ?? null;
            });

            return rowObj;
        });
    };
    const handleImportByStockId = (value) => {
        setIsImportByStockId(value)
        if (fileInputRef.current) {
            fileInputRef.current.value = ''; // Clear file input
        }
        funResetAction();


    }

    const funResetAction = () => {
        const upData = rows.map((ele) => ({ ...ele, isReturn: false, isFinal: false }))
        setRows(upData)
        setSelActionType("")
    }
    const handleImportXlChange = (value) => {
        setIsExcelImport(value)
        funResetAction()
        setIsImportByStockId(false)
        setChkGridSelAllFinal(false)
        setChkGridSelAllReturn(false)
    }

    const handleSellTypeUpload = (dataRows, actionType) => {
        const getColNo = (colName) =>
            excelTempData.find(ele => ele.tb_col_name === colName)?.xl_col_no;

        const L_Colno = getColNo('l_code');
        const Pkt_Colno = getColNo('pktno');
        const Stkid_Colno = getColNo('stoneid');

        if (!L_Colno || !Pkt_Colno) {
            toast.error("Missing column mapping for Lot No or Pkt No", {
                position: "top-center",
                toastId: "colMap",
            });
            return;
        }

        const mappedData = dataRows.map((row) => {
            const l_code = row[L_Colno - 1] ?? "";
            const pktno = row[Pkt_Colno - 1] ?? "";

            // const fillData = rows.filter((ele) => ele.lotNo == l_code && ele.pktNo == pktno)
            // if (fillData && fillData.length <= 0) {
            //     setExcelColMap(prev => [
            //         ...prev,
            //         { msg: `lot No : ${l_code} & Pkt No : ${pktno}` },
            //     ]);
            // }

            if (isImportByStockId) {
                const stockid = row[Stkid_Colno - 1] ?? "";
                return funGetLotNPktNoByStockID(stockid);
            }

            return { l_code, pktno };
        }).filter(row => row.l_code || row.pktno);

        const stockRow = rows.filter((ele) => ele.bWeight > 0)
        const updatedRows = [...stockRow]; // Clone once, outside loop

        mappedData.forEach((item) => {
            const matchIndex = updatedRows.findIndex(
                (ele) => String(ele.lotNo).toLowerCase() === String(item.l_code).toLowerCase() &&
                    String(ele.pktNo).toLowerCase() === String(item.pktno).toLowerCase()
            );
            //console.log(matchIndex, item)
            if (matchIndex === -1) {
                setExcelColMap((prev) => [
                    ...prev,
                    { msg: `lot No : ${item?.l_code} & Pkt No : ${item?.pktno}` },
                ]);
            } else {

                if (actionType == "final")
                    funSetAction(matchIndex, rows, RowsField.isFinal, true)
                else if (actionType == "return")
                    funSetAction(matchIndex, rows, RowsField.isReturn, true)

                //const updatedRows[matchIndex][RowsField.isFinal] = 1;
            }
        });
        // console.log(updatedRows)
        // setRows(updatedRows);

        // if (!newRows.length) return;

        // setRows(newRows);


    };
    const handleActionTypeChange = (value) => {
        setSelActionType(value)
        //funSetAction()
    }

    const handleFileUpload = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        if (selActionType && selActionType != null && selActionType != "") {
            const reader = new FileReader();
            setExcelColMap([]); // Reset column map before reading

            reader.onload = (event) => {
                const binaryStr = event.target.result;
                const workbook = XLSX.read(binaryStr, { type: 'binary' });
                const worksheet = workbook.Sheets[workbook.SheetNames[0]];
                const rows = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

                if (!rows?.length) return;

                const dataRows = rows.slice(1).filter((r) => r.length !== 0);
                const headers = rows[0]; // Not used here but might be needed elsewhere

                // if (selBillType === 'S') {
                handleSellTypeUpload(dataRows, selActionType);
                // }
            };

            reader.readAsBinaryString(file);

            // Reset file input so re-selecting same file triggers onChange

        }
        else {
            if (fileInputRef.current) {
                fileInputRef.current.value = '';
            }
            toast.error("Select Action Type", {
                position: "top-center",
                className: "toast-error"
            })
        }
        e.target.value = null;
    }
    const handleErrors = () => {
        if (ExcelColMap.length === 0) return;

        const fullMessage = ExcelColMap.map((ele) => {
            return `•  ${ele.msg}`
        }).join('\n');

        toast.warning(` Lot No & Pkt No Not Found In Memo :  \n ${fullMessage}`, {
            position: "top-center",
            className: "text-sm whitespace-pre-line p-2  text-gray-700", // preserve line breaks
            toastId: "excel-warnings",
            icon: false // single toast ID to prevent duplicates
        });

    }
    function CustomFooter() {
        const apiRef = useGridApiContext();
        const visibleRowIds = apiRef.current.getSortedRowIds();

        // ----------------------------
        // 1) Track synced scroll & grid width
        // ----------------------------
        const [scrollLeft, setScrollLeft] = useState(0);
        const [containerWidth, setContainerWidth] = useState(0);

        // Sync scroll from main grid
        useEffect(() => {
            const scroller = document.querySelector('.MuiDataGrid-virtualScroller');
            if (!scroller) return;

            const handleScroll = () => setScrollLeft(scroller.scrollLeft);
            scroller.addEventListener("scroll", handleScroll);

            return () => scroller.removeEventListener("scroll", handleScroll);
        }, []);

        // Track actual total column width to prevent right side cutoff
        useEffect(() => {
            const colContainer = document.querySelector('.MuiDataGrid-columnsContainer');
            if (!colContainer) return;

            const updateWidth = () => setContainerWidth(colContainer.scrollWidth);

            updateWidth();

            const observer = new ResizeObserver(updateWidth);
            observer.observe(colContainer);

            return () => observer.disconnect();
        }, []);

        // ----------------------------
        // 2) Visible rows & columns
        // ----------------------------
        const visibleRows = useMemo(() => {
            return visibleRowIds.map((id) =>
                apiRef.current.getRowWithUpdatedValues(id)
            );
        }, [apiRef, visibleRowIds]);

        const VisibleCol = apiRef.current.getAllColumns()


        // ----------------------------
        // 3) Totals calculation
        // ----------------------------
        const totals = useMemo(() => {
            const result = {};

            VisibleCol.forEach((col) => {
                if (col.type === "number") {
                    const sum = visibleRows.reduce(
                        (acc, row) => acc + parseFloat((row[col.field] || 0)),
                        0
                    );

                    if ([RowsField.pcs].includes(col.field)) {
                        result[col.field] = sum.toFixed(0);
                    } else if ([RowsField.weight, RowsField.bWeight, RowsField.retWeight].includes(col.field)) {
                        result[col.field] = sum.toFixed(3);
                    } else {
                        result[col.field] = sum.toFixed(2);
                    }
                } else {
                    result[col.field] = "";
                }
            });

            return result;
        }, [VisibleCol, visibleRows]);

        // ----------------------------
        // Render: Scroll-synced footer
        // ----------------------------
        return (
            <Box>

                {/* TOTAL FOOTER ROW (scroll synced + full width) */}
                <Box
                    display="flex"
                    width={containerWidth || "100%"}   // EXACT data column width → no clipping
                    position="relative"
                    left={-scrollLeft}                 // Horizontal sync
                    bgcolor="#FFFFFF"
                    color={"#c57205ff"}
                    p={1}
                >
                    {VisibleCol.map((col) => (
                        <Box
                            key={col.field}
                            fontWeight="bold"
                            minWidth={col.minWidth}
                            textAlign="right"
                            fontSize="11px"
                            textTransform="uppercase"
                            flex={col.flex}
                        >
                            {col.type === "number" && (
                                <div>
                                    <h6 style={{ margin: 0 }}>{col.headerName}</h6>
                                    {totals[col.field]}
                                </div>
                            )}
                        </Box>
                    ))}
                </Box>

                <GridPagination />
            </Box>
        );
    }
    if (isPending) {
        return <LoadingCard />;
    }
    if (isError || isErrorDetail) {
        return <ErrorCard />;
    }

    return (
        <div>
            <MainContainer
                pageName={` Finalize  ${entryLabel}   Memo Entry - ${selPktType == 'SNG' ? "Single Packet" : selPktType}`}
                breadcrumbs={[selBillType == 'S' ? "Sale" : 'Purchase', entryLabel, "Memo Entry", selPktType == 'SNG' ? "Single Packet" : selPktType]}
                prevPage={{
                    show: true,
                    onClick: handleClickPrev,
                }}
            >
                <Card shadow="sm" className="mb-3 w-full shadow p-3 bg-white">
                    <form onSubmit={handleSubmit} autoComplete='off'>
                        <CardBody>
                            {
                                Object.keys(inputBoxes).map((key, ind) => (
                                    <div key={key + ind}>
                                        <div className={` ${isMobile ? 'flex-wrap' : ''}   flex gap-4 align-top items-baseline mb-2 `}>
                                            {
                                                inputBoxes[key].map((item, indx) =>
                                                    item.type == ENUM_INPUT_TYPE.select ? (
                                                        <></>
                                                    ) : item.type == ENUM_INPUT_TYPE.autocomplete ? (
                                                        <>
                                                            <Autocomplete
                                                                size="md"
                                                                name={item.name}
                                                                isInvalid={errors[item.name]}
                                                                errorMessage={errors[item.name]}
                                                                label={item?.placeholder}
                                                                eventResizeFeature={true}
                                                                selectionMode="single"
                                                                showScrollIndicators={true}
                                                                labelPlacement={"outside"}
                                                                placeholder={item.placeholder}
                                                                isRequired={item.isrequired}
                                                                isLoading={isLoadingData}
                                                                className="max-w-23"
                                                                classNames={{
                                                                    label: "text-xs text-black font-bold",
                                                                }}
                                                                isClearable={false}
                                                                isVirtualized
                                                                readonly={true}
                                                                defaultItems={
                                                                    item.data ? item.data : []
                                                                }
                                                                onSelectionChange={(e) =>
                                                                    handleAutoCompleteChange(e, '', item.name)
                                                                }
                                                                //color={}
                                                                //onChange={handleFormSelectionChange}
                                                                selectedKey={formData[item.name]}
                                                            >
                                                                {(list) => (
                                                                    <AutocompleteItem

                                                                        key={list[item.itemkey]}
                                                                    >
                                                                        {list[item.itemvalue]}
                                                                    </AutocompleteItem>
                                                                )}
                                                            </Autocomplete>
                                                            {item.name == formField.partyId ?
                                                                <Chip className="cursor-pointer bg-slate-400" color={"default"} onClick={handleNewAcEntry}>New A/C.</Chip>
                                                                : ""}
                                                        </>
                                                    ) : item.type == ENUM_INPUT_TYPE.date ? (
                                                        <div className=" w-full flex items-center">
                                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                <DatePicker
                                                                    label={item.placeholder}
                                                                    views={["day", "month", "year"]}
                                                                    format="DD/MM/YYYY"
                                                                    readOnly={true}
                                                                    value={
                                                                        formData[item.name]
                                                                            ? dayjs(formData[item.name])
                                                                            : formData[item.name]
                                                                    }
                                                                    onChange={(newValue) => {
                                                                        setFormData((prev) => {
                                                                            return {
                                                                                ...prev,
                                                                                [item.name]: newValue != '' && newValue != 'Invalid Date' ?
                                                                                    dayjs(newValue).format("YYYY-MM-DD") : null,
                                                                            };
                                                                        });
                                                                    }}
                                                                    //isRequired={item.required}
                                                                    className="w-full "
                                                                    slotProps={{
                                                                        textField: { size: "small", error: errors[item.name], helperText: errors[item.name], required: true },
                                                                    }}
                                                                />
                                                            </LocalizationProvider>
                                                        </div>
                                                    ) : (

                                                        <Input
                                                            type={item.type}
                                                            name={item.name}
                                                            id={item.name}
                                                            isInvalid={errors[item.name]}
                                                            errorMessage={errors[item.name]}
                                                            placeholder={item.placeholder}
                                                            label={item.placeholder}
                                                            labelPlacement="outside"
                                                            isRequired={item.isrequired}
                                                            value={formData[item.name]}
                                                            variant="bordered"
                                                            onChange={(e) => handleChange(e)}
                                                            onBlur={(e) => hanldeBlur("", e)}
                                                            readOnly={true}
                                                            size={"md"}
                                                            classNames={{
                                                                label: "text-xs text-black font-bold",
                                                            }}
                                                        ></Input>
                                                    )
                                                )
                                            }
                                        </div>
                                    </div>
                                ))
                            }
                            <div className="mb-2">
                                {
                                    selTradeOf == 'P' && selPktType == 'SNG' && isNewEntry ?
                                        <div className="flex justify-end  gap-2 items-center my-2 px-5 ">
                                            {isExcelImport ?

                                                <Select
                                                    className="w-32 mr-2"
                                                    size="sm"
                                                    placeholder="--Action Type--"
                                                    color="danger"
                                                    selectedKeys={[selActionType]}
                                                    onChange={(e) => handleActionTypeChange(e.target.value)}
                                                >
                                                    <SelectItem key="final">  Final</SelectItem>
                                                    <SelectItem key="return">  Return</SelectItem>
                                                </Select>
                                                : ""}
                                            <Checkbox size="sm"
                                                classNames={{ "label": "text-white " }}
                                                className="py-1 px-2 rounded-md bg-green-800 border-blue-200 text-rose-700 border-0" label="gfu" color={"success"} isSelected={isExcelImport}
                                                onValueChange={(e) => handleImportXlChange(e)}>
                                                <FontAwesomeIcon className="mr-2" icon={faFileExcel} ></FontAwesomeIcon>
                                                Import From Excel</Checkbox>
                                            {isExcelImport ?
                                                <Checkbox size="sm"
                                                    classNames={{ "label": "text-rose-700  " }}
                                                    className=" py-1 px-2 ml-2  rounded-md bg-pink-100 border-blue-200 text-rose-700 border-0" label="gfu"
                                                    color={"danger"} isSelected={isImportByStockId}
                                                    onValueChange={handleImportByStockId}>
                                                    <FontAwesomeIcon className="mr-2" icon={faCircleLeft} ></FontAwesomeIcon>
                                                    Import By Stock ID</Checkbox>

                                                : ""}


                                        </div> : ""
                                }
                                {selTradeOf == 'P' && selPktType == 'SNG' && isNewEntry && isExcelImport ?
                                    <div className=" p-2">
                                        <div >
                                            <Input type="file" color="success" size="md" variant="flat"
                                                ref={fileInputRef}
                                                // className="w-1/2"
                                                classNames={{ label: "text-lg text-slate-700 font-semibold" }}
                                                // isRequired={isExcelImport}
                                                label="Import From Excel" accept=".xlsx, .xls" onChange={handleFileUpload} ></Input>
                                        </div>
                                        <div className="">
                                            {ExcelColMap && ExcelColMap.length > 0 ? (
                                                <Chip className="m-2  bg-red-200 text-red-700" onClick={handleErrors} >
                                                    <FontAwesomeIcon className="mr-2" icon={faExclamationTriangle}></FontAwesomeIcon>
                                                    warnings</Chip>
                                                // ExcelColMap.map((ele, index) => (
                                                //     <h5 className="text-xs text-red-700" key={index}>
                                                //         Lot No & Pkt No Not Found In Memo : <span className="text-green-500">{ele.msg}</span></h5>
                                                // ))

                                            ) : null}
                                        </div>
                                        {/* <h2 className="text-xs p-2 text-gray-300">{`In Excel Lot No Must Be In Column  ${ExcelColMap[0]?.lcode || " "}  & PktNo Must Be In Column:${ExcelColMap[0]?.pktno || " "} `}</h2> : ""} */}
                                    </div> : ""}
                            </div>
                            <div>
                                {rows && rows?.length > 0 ? (
                                    <Box sx={{ height: rows.length > 10 ? 600 : "auto", width: '100%' }}>
                                        <DataGrid
                                            rows={rows}
                                            columns={columns}
                                            editMode="row"
                                            // hideFooterPagination={false}
                                            // hideFooter={false}
                                            columnHeaderHeight={45}
                                            rowHeight={45}
                                            disableColumnSorting={true}
                                            disableColumnMenu={true}
                                            // slots={rows && rows.length > 0 ? {
                                            //     footer: CustomFooter,
                                            // } : {}}
                                            getRowClassName={(params) => {
                                                // if (params.id == 100) {
                                                //     return 'sticky-row';  // Add custom class to the last row
                                                // }
                                                return 'row-class';
                                            }}

                                            // getRowClassName={getRowClassName}
                                            sx={{
                                                '& .MuiDataGrid-columnHeaders': {
                                                    position: 'sticky',
                                                    top: 0,
                                                    zIndex: 1, // Make sure the headers are above the rows when scrolling

                                                },
                                                '& .row-class': {
                                                    fontSize: "12px",
                                                },
                                                '& .sticky-row': {
                                                    position: 'sticky',
                                                    bottom: 0,
                                                    color: "#c34c06",
                                                    backgroundColor: '#FFFFFF',
                                                    zIndex: 10,
                                                    height: 30, margin: 0,
                                                    fontWeight: "bold",
                                                    fontSize: "12px"

                                                },
                                                '& .MuiDataGrid-footerContainer': {
                                                    backgroundColor: "#FFFFFF !Important"
                                                },
                                                '& .sticky-row:hover': {
                                                    backgroundColor: "#ffffff"
                                                }
                                            }}
                                            columnVisibilityModel={{
                                                [RowsField.itemCode]: setColumnVisiblity(RowsField.itemCode),
                                                [RowsField.itemName]: setColumnVisiblity(RowsField.itemCode),
                                                [RowsField.lotNo]: setColumnVisiblity(RowsField.lotNo),
                                                [RowsField.pktNo]: setColumnVisiblity(RowsField.pktNo),
                                                [RowsField.shapeName]: setColumnVisiblity(RowsField.shapeCode),
                                                [RowsField.colorName]: setColumnVisiblity(RowsField.colorCode),
                                                [RowsField.purityName]: setColumnVisiblity(RowsField.purityCode),
                                                [RowsField.sizeName]: setColumnVisiblity(RowsField.sizeCode),
                                                [RowsField.lwRatio]: setColumnVisiblity(RowsField.lwRatio),
                                                [RowsField.reportNo]: setColumnVisiblity(RowsField.reportNo),
                                                [RowsField.lab]: setColumnVisiblity(RowsField.lab),
                                                [RowsField.rate]: setCurrencyColumnVisiblity(RowsField.rate),
                                                [RowsField.dRate]: setCurrencyColumnVisiblity(RowsField.dRate),
                                                [RowsField.amount]: setCurrencyColumnVisiblity(RowsField.amount),
                                                [RowsField.dAmount]: setCurrencyColumnVisiblity(RowsField.dAmount),
                                                [RowsField.convRate]: setCurrencyColumnVisiblity(RowsField.convRate),
                                                [RowsField.finalRate]: setCurrencyColumnVisiblity(RowsField.finalRate),
                                                [RowsField.dFinalRate]: setCurrencyColumnVisiblity(RowsField.dFinalRate),
                                            }}

                                        />

                                    </Box>
                                ) : (
                                    ""
                                )}
                            </div>
                            <div>
                                <div className="flex  items-top gap-2 mt-7 ">
                                    <Input
                                        size="sm"
                                        type="number"
                                        label="Total Weight"
                                        placeholder="Total Weight"
                                        value={Number(total_Weight ?? 0)}
                                        className="max-w-25"
                                        variant="flat"
                                        readOnly={true}
                                        color="success"
                                        classNames={{
                                            label: "text-xs text-black font-bold",
                                        }}
                                        startContent={
                                            <div className="pointer-events-none flex items-center">
                                                <span className="text-default-400 text-small">₹</span>
                                            </div>
                                        }
                                    />
                                    <Input
                                        size="sm"
                                        type="number"
                                        label="Total Net Amount"
                                        placeholder="Net Amount"
                                        value={Number(net_Amount ?? 0)}
                                        className="max-w-25"
                                        variant="flat"
                                        readOnly={true}
                                        color="success"
                                        classNames={{
                                            label: "text-xs text-black font-bold",
                                        }}
                                        startContent={
                                            <div className="pointer-events-none flex items-center">
                                                <span className="text-default-400 text-small">₹</span>
                                            </div>
                                        }
                                    />


                                    {CurrencySetting == ENUM_CURRENCY_SETTING_VAL.RS ? "" :
                                        <Input
                                            size="sm"
                                            type="number"
                                            label="Total Net Amount($)"
                                            placeholder="Net Amount($)"
                                            value={Number(net_AmountD ?? 0)}
                                            className="max-w-25"
                                            variant="flat"
                                            color="success"
                                            classNames={{
                                                label: "text-xs text-black font-bold",
                                            }}
                                            startContent={
                                                <div className="pointer-events-none flex items-center">
                                                    <span className="text-default-400 text-small">$</span>
                                                </div>
                                            }
                                        />}
                                </div>
                                <div className="flex  items-top gap-2 mt-7 ">
                                    <Input
                                        size="sm"
                                        type="number"
                                        label="Final Weight"
                                        placeholder="Weight"
                                        value={total_FinalWeight}
                                        className="max-w-25"
                                        variant="flat"
                                        color="danger"
                                        classNames={{
                                            label: "text-xs text-black font-bold",
                                        }}
                                        startContent={
                                            <div className="pointer-events-none flex items-center">
                                                <span className="text-default-400 text-small">$</span>
                                            </div>
                                        }
                                    />
                                    <Input
                                        size="sm"
                                        type="number"
                                        label="Final Net Amount(₹)"
                                        placeholder="NetAmount ₹"
                                        value={Final_Net_Amount}
                                        className="max-w-25"
                                        variant="flat"
                                        color="danger"
                                        classNames={{
                                            label: "text-xs text-black font-bold",
                                        }}
                                        startContent={
                                            <div className="pointer-events-none flex items-center">
                                                <span className="text-default-400 text-small">₹</span>
                                            </div>
                                        }
                                    />
                                    {CurrencySetting == ENUM_CURRENCY_SETTING_VAL.RS ? "" :
                                        <>
                                            <Input
                                                size="sm"
                                                type="number"
                                                label="Final Net Amount($)"
                                                placeholder="NetAmount $"
                                                value={Final_Net_AmountD}
                                                className="max-w-25"
                                                variant="flat"
                                                color="danger"
                                                classNames={{
                                                    label: "text-xs text-black font-bold",
                                                }}
                                                startContent={
                                                    <div className="pointer-events-none flex items-center">
                                                        <span className="text-default-400 text-small">$</span>
                                                    </div>
                                                }
                                            />

                                            <Input
                                                size="sm"
                                                type="number"
                                                label="Final Avg Rate($)"
                                                placeholder="Avg Rate($)"
                                                value={avg_RateD}
                                                className="max-w-25"
                                                variant="flat"
                                                color="danger"
                                                classNames={{
                                                    label: "text-xs text-black font-bold",
                                                }}
                                                startContent={
                                                    <div className="pointer-events-none flex items-center">
                                                        <span className="text-default-400 text-small">$</span>
                                                    </div>
                                                }
                                            />
                                        </>
                                    }
                                    <Input
                                        size="sm"
                                        type="number"
                                        label="Final Avg Rate(₹)"
                                        placeholder="Avg Rate(₹)"
                                        value={avg_Rate}
                                        className="max-w-25"
                                        variant="flat"
                                        color="danger"
                                        classNames={{
                                            label: "text-xs text-black font-bold",
                                        }}
                                        startContent={
                                            <div className="pointer-events-none flex items-center">
                                                <span className="text-default-400 text-small">₹</span>
                                            </div>
                                        }
                                    />

                                </div>
                            </div>
                            <div className="justify-center flex gap-5 mt-5">
                                <Button
                                    color="primary"
                                    type="submit"
                                    size="md"
                                    variant="shadow"
                                    isDisabled={isDisableSubmit()}
                                    disabled={isNewEntry ? false : true}
                                    startContent={<FontAwesomeIcon icon={faSave} />}
                                >
                                    Generate
                                </Button>
                                <Button
                                    color="danger"
                                    variant="shadow"
                                    size="md"
                                    onPress={handleClickPrev}
                                    startContent={<FontAwesomeIcon icon={faCancel} />}
                                >
                                    Cancel
                                </Button>
                            </div>
                        </CardBody>
                    </form >
                </Card >
            </MainContainer>
        </div >
    )

}
export default MemoFinalization

// {
//     field: RowsField.shapeCode,
//     headerName: "S_Code",
//     width: 100,
//     headerAlign: "center",
//     headerClassName: itemGridHeadClass,
//     renderCell: ({ row }) => (
//         <div>{
//             funIsFooter(row.id) ? "" :
//                 renderInputCell(row, RowsField.shapeCode, "text", true, "", false, "", "")
//         }
//         </div>
//     )
// },